'use client';

import {
  OverlayScrollbarsComponent,
  type OverlayScrollbarsComponentProps,
} from 'overlayscrollbars-react';

import {
  mergeScrollAreaOptions,
  SCROLL_AREA_DEFER,
} from './scroll-area.helpers';

// test-exception: overlayscrollbars wrapper + JSX only, no extractable logic
function ScrollArea({
  className,
  options,
  defer = SCROLL_AREA_DEFER,
  ...props
}: OverlayScrollbarsComponentProps) {
  return (
    <OverlayScrollbarsComponent
      data-test='scroll-area'
      defer={defer}
      className={className}
      options={mergeScrollAreaOptions(options)}
      {...props}
    />
  );
}

export default ScrollArea;
